export default __webpack_public_path__ + "static/media/logo180.7bc1467d.png";